<template lang="pug">
NavigationMenu(v-if="showDashboardLink" :viewport="false" class="header-account-nav relative z-50" :class="{ 'is-light': props.isLightHeader }")
  NavigationMenuList
    NavigationMenuItem(value="account-menu")
      NavigationMenuTrigger(class="nav-menu-trigger h-[2.125rem] w-[2.125rem] min-w-[2.125rem] p-0 [&>svg]:hidden" :aria-label="$t('header.dashboard')")
        div.flex.items-center(class="gap-1.5")
          PandaMascot(class="header-icon")
      NavigationMenuContent(class="nav-menu-panel absolute left-auto right-0 top-full mt-2 w-[min(260px,calc(100vw-2rem))] rounded-[var(--nav-menu-radius)] border border-border/60 bg-popover text-popover-foreground shadow md:right-2 md:w-auto md:mt-2" style="--nav-menu-radius: 0.75rem;")
        ul.nav-menu-list(class="grid gap-2 w-[260px] sm:w-[300px]")
          //- User Info Section
          li.balance-section.border-b(v-if="visitorSession.isAdmin || !user.extra?.suspend" class="border-border/50")
            NavigationMenuLink(v-if="visitorSession.isAdmin" as-child)
              NuxtLink.nav-menu-item.mb-2(:to="dashboardLink")
                Icon(name="material-symbols:account-circle" class="nav-menu-icon text-primary")
                div.nav-menu-content(v-if="user.email && user.id !== -1")
                  div.font-semibold.text-xs(class="sm:text-sm") {{ user.email || `User ${userId}` }}
                  div.text-xs.text-muted-foreground ID: {{ userId }}

            //- Balance display
            div.balance-panel.px-1.rounded-lg(:class="{ 'mt-2': visitorSession.isAdmin }" class="sm:px-2")
              div.flex.items-center.justify-between
                div.flex.items-center.gap-4
                  Icon(
                    name="streamline:money-cash-coins-stack-accounting-billing-payment-stack-cash-coins-currency-money-finance"
                    class="h-4 w-4 sm:h-5 sm:w-5 nav-menu-icon--money"
                  )
                  span.font-bold.text-xs(class="sm:text-sm") {{ $utils.currency(user.money, user.balance_currency) }}
                div(v-if="topUpLink")
                  NavigationMenuLink(as-child)
                    NuxtLink.top-up-action.text-xs(v-if="topUpLink" :to="topUpLink")
                      | {{ $t('pricing.topup') }} →

          //- Main Navigation Links
          li
            NavigationMenuLink(as-child)
              NuxtLink.nav-menu-item(:to="dashboardLink")
                Icon(name="material-symbols:dashboard-customize-rounded" class="nav-menu-icon")
                div.nav-menu-content
                  div.font-medium {{ $t('header.dashboard') }}
                  div.text-xs.text-muted-foreground
                    | {{ $t('header.dashboard_subtitle') }}
                    template(v-if="!visitorSession.isAdmin && userId !== -1")  · ID: {{ userId }}

          li(v-if="visitorSession.isAdmin || !user.extra?.suspend")
            NavigationMenuLink(as-child)
              NuxtLink.nav-menu-item(:to="billLink")
                Icon(name="solar:bill-list-linear" class="nav-menu-icon")
                div.nav-menu-content
                  div.font-medium {{ $t('billing.title') }}
                  div.text-xs.text-muted-foreground {{ $t('billing.dropdown_subtitle') }}

          li
            NavigationMenuLink(as-child)
              NuxtLink.nav-menu-item(:to="`${dashboardLink}/dedicated`")
                Route(class="nav-menu-icon" aria-hidden="true")
                div.nav-menu-content
                  div.font-medium {{ $t('my_lines.title') }}
                  div.text-xs.text-muted-foreground {{ $t('my_lines.nav_hint') }}


          li
            NavigationMenuLink(as-child)
              NuxtLink.nav-menu-item(:to="settingLink")
                Icon(name="teenyicons:adjust-horizontal-outline" class="nav-menu-icon")
                div.nav-menu-content
                  div.font-medium {{ $t('account_settings') }}
                  div.text-xs.text-muted-foreground {{ $t('setting.dropdown_subtitle') }}

          li
            NavigationMenuLink(as-child)
              NuxtLink.nav-menu-item(:to="orgDashboardLink")
                Icon(name="mdi:office-building" class="nav-menu-icon")
                div.nav-menu-content
                  div.font-medium {{ $t('org.dashboard.title') }}
                  div.text-xs.text-muted-foreground {{ $t('org.nav.subtitle') }}


          //- Support Section
          li.border-t.pt-2
            NavigationMenuLink(as-child)
              NuxtLink.nav-menu-item(:to="supportLink")
                Icon(name="iconoir:headset-help" class="nav-menu-icon")
                div.nav-menu-content
                  div.font-medium {{ $t('support.dropdown_title') }}

          li
            NavigationMenuLink(as-child)
              NuxtLink.nav-menu-item(:to="refLink")
                Icon(name="solar:gift-linear" class="nav-menu-icon")
                div.nav-menu-content
                  div.font-medium {{ $t('ref.dropdown_title') }}

          //- Admin Section
          template(v-if="visitorSession.isAdmin")
            li.border-t.pt-2
              NavigationMenuLink(as-child)
                NuxtLink.nav-menu-item(:to="profileLink")
                  Icon(name="material-symbols:lab-profile-outline-rounded" class="nav-menu-icon")
                  div.nav-menu-content
                    div.font-medium 用户Profile
                    //- div.text-xs.text-muted-foreground 查看详细用户资料

            li
              NavigationMenuLink(as-child)
                button.nav-menu-item.w-full(@click="visitorSession.switchAdminStatus()")
                  Icon(name="ep:switch" class="nav-menu-icon")
                  div.nav-menu-content.text-left
                    div.font-medium 切换管理员状态
                    //- div.text-xs.text-muted-foreground {{ visitorSession.isAdmin ? '退出' : '进入' }}管理员模式

            //- Logout
          li.border-t.pt-2.pl-1
            NavigationMenuLink(as-child)
              button.nav-menu-item.w-full(@click="logout")
                Icon(name="mdi:logout" class="nav-menu-icon")
                div.nav-menu-content.text-left
                  div.font-medium {{ $t('header.logout') }}
</template>

<script lang="ts" setup>
import { Route } from 'lucide-vue-next'
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu'
import { toast } from '~/utils/sonner'

const $i18n = useI18n()
const $t = $i18n.t
const user = useUser()
const visitorSession = useVisitorSession()
const $utils = useUtils()

const props = defineProps<{
  isLightHeader?: boolean
  showDashboardLink: boolean
  dashboardLink: string
  userId: number
  billLink: string
  settingLink: string
  supportLink: string
  refLink: string
  profileLink: string
  topUpLink?: string
}>()

const emit = defineEmits<{
  logout: []
}>()

const orgDashboardLink = computed(() => {
  if (!visitorSession.loggedIn) return ''
  const orgId = (user as any)?.org_id
  const base = orgId ? `/orgdashboard/${orgId}` : '/orgdashboard'
  const sessionUserId = Number(visitorSession.user_id || 0)
  const targetUserId = Number(user.id || 0)
  if (visitorSession.realAdmin && sessionUserId && targetUserId && sessionUserId !== targetUserId) {
    return `${base}?asUser=${targetUserId}`
  }
  return base
})

const logout = async () => {
  const ret = await useDialog().confirm({
    title: $t('settings_page.logout.warning.title'),
    body: $t('settings_page.logout.warning.content'),
    confirmButtonText: $t('settings_page.logout.warning.title'),
    cancelButtonText: $t('service_selector.cancel'),
  })
  if (ret !== 'confirm') {
    return
  }
  visitorSession.logout()
  toast({
    title: $t('settings_page.logout.suc'),
  })
  window?.location?.reload()
}
</script>

<style lang="postcss" scoped>

.header-account-nav {
  --nav-menu-text: #f5f7f1;
  --nav-menu-muted: #858d81;
  --nav-menu-trigger-color: var(--nav-menu-muted);
  --nav-menu-green: #7ed321;
  --nav-menu-panel-bg: #0c100c;
  --nav-menu-panel-border: rgba(245, 247, 241, 0.1);
  --nav-menu-hover-bg: rgba(126, 211, 33, 0.1);
  --nav-menu-active-bg: rgba(126, 211, 33, 0.14);
  --nav-menu-shadow: 0 20px 60px rgba(0, 0, 0, 0.34);
  --popover: var(--nav-menu-panel-bg);
  --popover-foreground: var(--nav-menu-text);
  --primary: var(--nav-menu-green);
  --accent: var(--nav-menu-hover-bg);
  --accent-foreground: var(--nav-menu-text);
  --muted-foreground: var(--nav-menu-muted);
  --border: var(--nav-menu-panel-border);
}

.header-account-nav.is-light {
  --nav-menu-text: #1e293b;
  --nav-menu-muted: #64748b;
  --nav-menu-green: #2d5a27;
  --nav-menu-panel-bg: #fff;
  --nav-menu-panel-border: rgba(51, 65, 85, 0.15);
  --nav-menu-hover-bg: #f8fafc;
  --nav-menu-active-bg: #f1f5f9;
  --nav-menu-shadow: 0 18px 48px rgba(51, 65, 85, 0.1);
}

.header-icon {
  vertical-align: middle;
  font-size: 20px;
  color: var(--nav-menu-trigger-color);
  transition: color 0.2s ease;
}

.nav-menu-trigger {
  flex: 0 0 2.125rem;
  width: 2.125rem;
  min-width: 2.125rem;
  height: 2.125rem;
  padding: 0 !important;
  color: var(--nav-menu-trigger-color) !important;
}

.nav-menu-trigger :deep(> svg) {
  display: none;
}

@media (max-width: 480px) {
  .header-account-nav {
    flex: 0 0 2.125rem;
    width: 2.125rem;
    margin-inline-end: 0.25rem;
  }
}

.nav-menu-trigger :deep(svg) {
  color: var(--nav-menu-trigger-color) !important;
}

.nav-menu-trigger:hover,
.nav-menu-trigger:focus-visible,
.nav-menu-trigger[data-state='open'] {
  color: var(--nav-menu-green) !important;
}

.nav-menu-trigger:hover :deep(svg),
.nav-menu-trigger:focus-visible :deep(svg),
.nav-menu-trigger[data-state='open'] :deep(svg),
.nav-menu-trigger:hover .header-icon,
.nav-menu-trigger:focus-visible .header-icon,
.nav-menu-trigger[data-state='open'] .header-icon {
  color: var(--nav-menu-green) !important;
}

.nav-menu-panel {
  border-color: var(--nav-menu-panel-border) !important;
  background: var(--nav-menu-panel-bg) !important;
  color: var(--nav-menu-text) !important;
  box-shadow: var(--nav-menu-shadow) !important;
  -webkit-backdrop-filter: none;
  backdrop-filter: none;
}

.nav-menu-list {
  --nav-item-pad-y: 0.45rem;
  --nav-item-pad-x: 0.2rem;
  --nav-item-pad: var(--nav-item-pad-y);
  padding: var(--nav-item-pad-y) var(--nav-item-pad-x);
  color: var(--nav-menu-text);

  li {
    padding-left: 0;
    border-radius: 0;
  }
}

.nav-menu-list .border-b,
.nav-menu-list .border-t {
  border-color: var(--nav-menu-panel-border) !important;
}

/* Without a panel background, keep equal space above and below the balance row. */
.balance-section {
  padding-bottom: var(--nav-item-pad-y);
}

.balance-panel {
  padding-block: var(--nav-item-pad-y);
  color: var(--nav-menu-text);
}

.top-up-action {
  display: inline-block;
  /* The pill's vertical padding must not grow the balance row. */
  margin-block: -0.25rem;
  padding: 0.25rem 0.7rem;
  border-radius: 9999px;
  background: rgba(126, 211, 33, 0.14);
  color: var(--nav-menu-green);
  font-weight: 850;
  transition: background-color 0.15s ease;
}

.top-up-action:hover {
  background: rgba(126, 211, 33, 0.24);
  color: var(--nav-menu-green);
}

.header-account-nav.is-light .top-up-action {
  background: rgba(45, 90, 39, 0.08);
}

.header-account-nav.is-light .top-up-action:hover {
  background: rgba(45, 90, 39, 0.14);
}

.nav-menu-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  width: 100%;
  border-radius: clamp(0px, calc(var(--nav-menu-radius) - var(--nav-item-pad)), var(--nav-menu-radius));
  padding: var(--nav-item-pad-y) var(--nav-item-pad-x);
  font-size: 0.95rem;
  line-height: 1.35rem;
  color: var(--nav-menu-text);
  transition: background-color 0.2s ease, color 0.2s ease;
}

@media (max-width: 640px) {
  .nav-menu-item {
    font-size: 0.85rem;
    line-height: 1.2rem;
  }
}

.nav-menu-item,
.nav-menu-list li {
  padding-inline: var(--nav-item-pad-x);
  /* padding-left: calc(var(--nav-item-pad-x) + 0.2rem); */
}

@media (min-width: 640px) {
  .nav-menu-list {
    --nav-item-pad-y: 0.4rem;
    --nav-item-pad-x: 0.175rem;
    --nav-item-pad: var(--nav-item-pad-y);
  }
}

.nav-menu-item:hover,
.nav-menu-item:focus {
  background-color: var(--nav-menu-hover-bg);
  color: var(--nav-menu-text);
  outline: none;
}

.nav-menu-item:hover .text-muted-foreground,
.nav-menu-item:focus .text-muted-foreground {
  color: var(--nav-menu-muted) !important;
}

.nav-menu-item[data-disabled] {
  pointer-events: none;
  opacity: 0.5;
}

.nav-menu-icon {
  box-sizing: border-box;
  padding: 0;
  width: 1.6rem;
  height: 1.125rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--nav-menu-muted);
}

.nav-menu-item:hover .nav-menu-icon,
.nav-menu-item:focus .nav-menu-icon,
.nav-menu-item.router-link-active .nav-menu-icon {
  color: var(--nav-menu-green);
}

.nav-menu-icon.text-red-500,
.nav-menu-item:hover .nav-menu-icon.text-red-500,
.nav-menu-item:focus .nav-menu-icon.text-red-500 {
  color: #ef4444;
}

.nav-menu-icon--money {
  /* margin-left: -0.4rem; */
  padding-left: 1.4rem;
}

@media (min-width: 640px) {
  .nav-menu-icon {
    height: 1.375rem;
  }
}

.nav-menu-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.nav-menu-content .text-muted-foreground,
.nav-menu-panel .text-muted-foreground {
  color: var(--nav-menu-muted) !important;
}

/* Active state for current page */
.nav-menu-item.router-link-active {
  background: var(--nav-menu-active-bg);
}
</style>
